export const dateMixin = {
	methods: {
		date_to_ymd(date) {
			let ymd = date.getFullYear();

			let month = 1 + date.getMonth();
			if (month < 10) {
				ymd = ymd + '0' + month;
			} else {
				ymd = ymd + '' + month;				
			}

			let day = date.getDate();
			if (day < 10) {
				ymd = ymd + '0' + day;
			} else {
				ymd = ymd + '' + day;				
			}

			return ymd;
		},		
		date_to_iso8601(date) {
			let ymd = date.getFullYear();

			ymd = ymd + '-';

			let month = 1 + date.getMonth();
			if (month < 10) {
				ymd = ymd + '0' + month;
			} else {
				ymd = ymd + '' + month;				
			}

			ymd = ymd + '-';

			let day = date.getDate();
			if (day < 10) {
				ymd = ymd + '0' + day;
			} else {
				ymd = ymd + '' + day;				
			}
			return ymd;
		},	
		ymd_to_date(date)	{
			if (date == null) {
				return null;
			} else {
				// YYYY-MM-DD

				let ymdtodate = date.substr(0,4); 
				ymdtodate += '-';
				ymdtodate += date.substr(4,2);
				ymdtodate += '-';
				ymdtodate += date.substr(6,2);
				
				return new Date(ymdtodate);
			}
		},
		day_of_the_week(date) {
			if (date == null) {
				return '';
			} else {
				const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

				return days[date.getDay()];
			}

		},
		format_date(date) {
			if (date == null) {
				return '';
			} else {
				const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

				let day = date.getDate();
				let month = months[date.getMonth()]; // 0 - 11 !!!!
				let year = date.getFullYear();

				return `${day} ${month} ${year}`;
			}
		},
		add_days(date, add) {
			// don't get why javascript doesn't seem to have add/subtract functions...

			// get our time in milliseconds since January 1, 1970
			let time = date.getTime(); 

			// add our days in milliseconds
			time += add * 24 * 60 * 60 * 1000;

			// create our new date
			let new_date = new Date();
			new_date.setTime(time);

			return new_date;
		}
	}
}